import React, { useEffect, useState, Suspense } from "react";
import { useForm } from 'react-hook-form'
import { Loader } from "src/components/Parts/loaderParts";
import { Useable } from 'src/utils/Useable';
import { fetchAreas, fetchCities, fetchStores } from 'src/data/fetch'
import { FlowParts } from "../Parts/flowParts";

const AreaList = (props) => {
    const {data:areas} = props.data.getOrThrow()

    return (
      <ul className="select_list area_list">
        <li  onClick={() => props.onSelectArea({id:0, name:`エリア\nを選択`})}> エリアを選択</li>
      {
         areas.map((a,i) => {
          return(
            <li key={i} 
              onClick={() => props.onSelectArea({id:a.id, name:a.name})}>
                {a.name}
              </li>
          )
        })
      } 
      </ul>
    )
}

const CityList = (props) => {
  const {data:cities} = props.data.getOrThrow()
  return (
    <ul className="select_list city_list">
        <li  onClick={() => props.onSelectCity({id:0, name:`市区町村\nを選択`})}> 市区町村を選択</li>
    {
       cities.map((c,i) => {
        return(
          <li key={i}
            onClick={() => props.onSelectCity({id:c.id, name:c.name})}
            >{c.name}</li>
        )
      })
    } 
    </ul>
  )
}


export const StoreSearchView = (props) => {
 

  //エリア情報
  const [areas, setArea] = useState(0)
  const [selectArea, setSelectArea] = useState(props.defaultValue.area)
  const [openArea, setOpenArea] = useState(0)
  useEffect(() => {
    setArea(
        new Useable( fetchAreas())
    ) 
  },[]);

  const openAreaList = () => {
      setOpenCity(0)
      setOpenKeyword(0)
      if(areas !== 0) openArea ? setOpenArea(0) : setOpenArea(1)
  }
  const onSelectArea = (area) => {
    setSelectArea(area)
    setOpenArea(0)
    //市町村リセット.
    setSelectCity({id:0, name:'市区町村\nを選択'})
    setOpenCity(0)
  }

  //市町村情報
  const [cities, setCities] = useState(0)
  const [openCity, setOpenCity] = useState(0)
  const [selectCity, setSelectCity] = useState(props.defaultValue.city)
  useEffect(() => {
    setCities(
      new Useable( fetchCities(selectArea.id))
    )
  },[selectArea]);

  const openCityList = () => {
      setOpenArea(0)
      setOpenKeyword(0)
      if(cities !== 0) openCity ? setOpenCity(0) : setOpenCity(1)
  }
  const onSelectCity = (city) => {
    setSelectCity(city)
    setOpenCity(0)
  }

  //input情報
  const [keyword, setKeyword] = useState(props.defaultValue.keyword)
  const { register, handleSubmit } = useForm()
  const [openKeyword, setOpenKeyword] = useState(0)

  const onKeyword = () => {
    setOpenArea(0)
    setOpenCity(0)
    openKeyword ? setOpenKeyword(0) : setOpenKeyword(1)
  }
  const onKeywordSubmit = (currentInput) => {
    setKeyword(currentInput.keyword)
    setOpenKeyword(0)
  }
  const inputReset = () => {
    setKeyword('')
    setOpenKeyword(0)
  }


  //searchQuery  
  const onSearch = () => {

      props.onSearch({
        area: selectArea,
        city: selectCity,
        keyword: keyword
      })
  }

  return (
  <div className="select_content">
		<div className="select_desc">ご購入またはご契約の販売店の情報を入力して検索ボタンを押してください</div>
      <p className="mb-20">※未選択でも検索ボタンから候補店舗を表示します。</p>
      <div className="tile a1-b1-c3 am20-bm20-cm20-dm30">
          {/* Area List */}
          <div>
            <div className="select_box">
              <a className="btn4" id="area_select" 
                onClick={() => {openAreaList()}}>{selectArea.name}
              </a>
                {areas !== 0 &&
                  <Suspense>
                    { openArea !== 0 &&
                      <AreaList {...{
                          data:areas,
                          onSelectArea
                          }}></AreaList>
                    }
                  </Suspense> 
                  }
            </div>
          </div>
          
          {/* City List */}
          <div>
            <div className="select_box">
              <a className="btn4" id="city_select"
                onClick={() => {openCityList()}}>{selectCity.name}
              </a>
               {cities !== 0 &&
                <Suspense>
                  { openCity !== 0 &&
                    <CityList {...{
                        data:cities,
                        onSelectCity}}></CityList>
                  }
                </Suspense> 
                }
            </div>
          </div>
          {/* keyword */}
          <div>
            <div className="select_box">
              <a className="btn4" id="shop_input" 
                onClick={() => { onKeyword() }}>
                    {keyword ? keyword : '販売店名\nを入力'}
              </a>
              { openKeyword !== 0 &&
                <form className="keyword_input" onSubmit={handleSubmit(onKeywordSubmit)}>
                  <p className="mb-10">ご購入またはご契約の販売店名の全部または一部を入力してください。</p>
                  <input type="text" placeholder="入力" className="f-text" id="shop_keyword"  {...register("keyword")}/>
                  <button type="submit" className="btn7 mt-15" id="keyword_close">入力完了</button>
                  <a className="btn7 mt-15" id="keyword_close" onClick={() => { inputReset() }}>リセット</a>
                </form>
              }
            </div>
          </div>
            
        </div>
        <div className="block1 w-500">
          <div className="block1_1" onClick={ () => {onSearch()}}><button className="btn5" type="submit">検索</button></div>
          <div className="block1_2" onClick={ () => { props.prev() }}><a className="btn6">戻る</a></div>
        </div>
    </div>
    
  )
}

